import { z } from 'zod';
import { CustomErrorParams, CustomErrorType } from '../../CustomErrorType';

export const dateStringValidationError: z.IssueData = {
    code: z.ZodIssueCode.custom,
    params: { errorType: CustomErrorType.DateString } satisfies CustomErrorParams,
    fatal: true,
};
